<template>
  <v-dialog v-model="mainStore.rfr26InscriptionGate.showDialog" width="500" max-width="100%" scroll-strategy="none"
    persistent>
    <v-card>
      <v-card-title class="text-h6 font-weight-bold text-darkblue">
        Vérification du code postal
      </v-card-title>
      <v-card-text>
        <p class="mb-4">
          Merci de renseigner votre code postal pour continuer votre inscription.
        </p>
        <v-text-field v-model="codePostal" label="Code postal" maxlength="5" inputmode="numeric"
          :error-messages="errorMessage" @keyup.enter="submit" autofocus />
      </v-card-text>
      <v-card-actions class="px-4 pb-4">
        <v-btn color="darkblue" variant="text" @click="close">
          Annuler
        </v-btn>
        <v-btn color="darkblue" variant="elevated" elevation="0" @click="submit">
          Continuer
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";

export default {
  data() {
    return {
      codePostal: "",
    };
  },
  computed: {
    ...mapStores(useMainStore),
    errorMessage() {
      if (this.mainStore.rfr26InscriptionGate.showRejectedMessage) {
        return "Les inscriptions sont réservées aux Roquebrunois jusqu'au 13 septembre 2026.";
      }
      return "";
    },
  },
  watch: {
    "mainStore.rfr26InscriptionGate.showDialog"(isOpen) {
      if (isOpen) {
        this.codePostal = "";
      }
    },
  },
  methods: {
    submit() {
      this.mainStore.confirmRFR26CodePostal(this.codePostal);
    },
    close() {
      this.mainStore.closeRFR26InscriptionDialog();
    },
  },
};
</script>
